import React from 'react'
import { Button, Input, H2, Span } from '../../lib/components'
import { IFormProps } from '../../lib/types'
import { FormikProps, Formik } from 'formik'

type FormValues = {
  currentPassword: string
  newPassword: string
  newPasswordConfirmation: string
}

const AccountChangePasswordPresenter = ({
  initialValues,
  handleFormSubmit,
  validationSchema,
}: IFormProps<FormValues, FormValues>) => {
  return (
    <>
      <H2 classes={['mt-8 mb-12']} text='Change password' />
      <Span
        classes={['account-change-password-lead']}
        text='Use a strong password. Other devices where you were signed in will be signed out.'
        variant='default'
      />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
      >
        {(formik) => {
          const {
            values,
            touched,
            errors,
            dirty,
            handleChange,
            handleSubmit,
          }: FormikProps<FormValues> = formik
          return (
            <form className='account-change-password-form mt-24'>
              <Input
                labelText='Current password'
                name='currentPassword'
                placeholder='********'
                type='password'
                required
                value={values.currentPassword}
                handleChange={handleChange(initialValues.currentPassword)}
                dirty={dirty}
                errors={{
                  currentPassword:
                    !!errors && errors.currentPassword ? errors.currentPassword : null,
                }}
                touched={{
                  currentPassword: !!touched && !!touched.currentPassword,
                }}
                dataTestId='account-change-password-current'
              />
              <div className='mt-16'>
                <Input
                  labelText='New password'
                  name='newPassword'
                  placeholder='********'
                  type='password'
                  required
                  value={values.newPassword}
                  handleChange={handleChange(initialValues.newPassword)}
                  dirty={dirty}
                  errors={{
                    newPassword: !!errors && errors.newPassword ? errors.newPassword : null,
                  }}
                  touched={{ newPassword: !!touched && !!touched.newPassword }}
                  dataTestId='account-change-password-new'
                />
              </div>
              <div className='mt-16'>
                <Input
                  labelText='Confirm new password'
                  name='newPasswordConfirmation'
                  placeholder='********'
                  type='password'
                  required
                  value={values.newPasswordConfirmation}
                  handleChange={handleChange(initialValues.newPasswordConfirmation)}
                  dirty={dirty}
                  errors={{
                    newPasswordConfirmation:
                      !!errors && errors.newPasswordConfirmation
                        ? errors.newPasswordConfirmation
                        : null,
                  }}
                  touched={{
                    newPasswordConfirmation: !!touched && !!touched.newPasswordConfirmation,
                  }}
                  dataTestId='account-change-password-confirm'
                />
              </div>
              <Button
                classes={['mt-24', 'mb-8', 'account-change-password-submit']}
                variant='primary-btn'
                text='Update password'
                handleClick={handleSubmit}
                dataTestId='account-change-password-submit'
              />
            </form>
          )
        }}
      </Formik>
    </>
  )
}

export { AccountChangePasswordPresenter }
